export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5, user-scalable=yes, viewport-fit=cover","tagPriority":"critical"},{"name":"name","content":"Cezma | سيزما","tagPriority":"critical"},{"name":"image","content":"/assets/logo.jpg","tagPriority":"critical"},{"name":"apple-mobile-web-app-status-bar-style","content":"default","tagPriority":"critical"},{"name":"mobile-web-app-capable","content":"yes","tagPriority":"critical"},{"name":"keywords","content":"online shopping, clothes, real estate, electronics","tagPriority":"critical"},{"name":"author","content":"HMASERV","tagPriority":"critical"},{"property":"og:title","content":"Cezma | سيزما","tagPriority":"critical"},{"property":"og:url","content":"https://cezma.com","tagPriority":"critical"},{"name":"description","content":"اكبر وافضل متجر الكترونى فى الشرق الأوسط مابين التاجر والمشترى بدون وسيط","tagPriority":"critical"},{"property":"og:description","content":"اكبر وافضل متجر الكترونى فى الشرق الأوسط مابين التاجر والمشترى بدون وسيط","tagPriority":"critical"},{"property":"og:type","content":"website","tagPriority":"critical"},{"property":"og:image","content":"/assets/logo.jpg","tagPriority":"critical"},{"property":"og:locale","content":"ar_EG","tagPriority":"critical"},{"property":"og:locale:alternate","content":"en_US","tagPriority":"critical"},{"property":"og:site_name","content":"سيزما","tagPriority":"critical"},{"name":"apple-mobile-web-app-title","content":"سيزما","tagPriority":"critical"},{"name":"twitter:card","content":"summary_large_image","tagPriority":"critical"},{"name":"twitter:title","content":"Cezma | سيزما","tagPriority":"critical"},{"name":"twitter:image","content":"/assets/logo.jpg","tagPriority":"critical"},{"name":"twitter:image:alt","content":"Cezma | سيزما","tagPriority":"critical"},{"name":"twitter:app:country","content":"EGY","tagPriority":"critical"},{"name":"og:country-name","content":"EGY","tagPriority":"critical"},{"name":"theme-color","content":"#0758E7","tagPriority":"critical"},{"name":"color-scheme","content":"light","tagPriority":"critical"},{"property":"al:ios:app_name","content":"Cezma","tagPriority":"critical"},{"property":"al:ios:app_store_id","content":"6460079151","tagPriority":"critical"},{"property":"al:ios:url","content":"cezma://","tagPriority":"critical"},{"property":"al:android:app_name","content":"Cezma","tagPriority":"critical"},{"property":"al:android:package","content":"com.cezmastore.app","tagPriority":"critical"},{"property":"al:android:url","content":"cezma://","tagPriority":"critical"}],"link":[{"rel":"alternate","href":"https://cezma.com","hreflang":"x-default","tagPriority":"critical"},{"rel":"alternate","href":"https://cezma.com?locale=en","hreflang":"en","tagPriority":"critical"},{"rel":"alternate","href":"https://cezma.com?locale=ar","hreflang":"ar","tagPriority":"critical"}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtag/js?id=G-652NXZM3LT","async":true,"type":"application/json"},{"src":"/notificationsEnvMode.js","type":"text/javascript"},{"children":"\n        window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());        \n\n        gtag('config', 'G-652NXZM3LT')\n        "},{"children":"\n            !(function (f, b, e, v, n, t, s) {\n              if (f.fbq) return;\n              n = f.fbq = function () {\n                n.callMethod\n                  ? n.callMethod.apply(n, arguments)\n                  : n.queue.push(arguments);\n              };\n              if (!f._fbq) f._fbq = n;\n              n.push = n;\n              n.loaded = !0;\n              n.version = \"2.0\";\n              n.queue = [];\n              t = b.createElement(e);\n              t.async = !0;\n              t.src = v;\n              s = b.getElementsByTagName(e)[0];\n              s.parentNode.insertBefore(t, s);\n            })(\n              window,\n              document,\n              \"script\",\n              \"https://connect.facebook.net/en_US/fbevents.js\"\n            );\n            fbq(\"init\", 1074137274284200);\n            fbq(\"track\", \"PageView\");\n        "}],"noscript":[],"title":"Cezma | سيزما"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false